import { useNavigate, useRouter } from '@tanstack/react-router'
import { cn } from '@/lib/utils'
import { Button } from '@/components/ui/button'
import { useTranslation } from '@/hooks/useTranslation'
import { getDefaultNavigationUrl } from '@/lib/navigation-utils'
import useAuth from '@/hooks/use-auth'

interface GeneralErrorProps extends React.HTMLAttributes<HTMLDivElement> {
  minimal?: boolean
}

export default function GeneralError({
  className,
  minimal = false,
}: GeneralErrorProps) {
  const navigate = useNavigate()
  const { history } = useRouter()
  const { t } = useTranslation()
  const { user, hasPermission } = useAuth()

  const handleBackToHome = () => {
    const userPermissions = user?.permissions?.map(p => p.name) || [];
    const targetUrl = getDefaultNavigationUrl(userPermissions, hasPermission);
    navigate({ to: targetUrl });
  };

  return (
    <div className={cn('h-svh w-full', className)}>
      <div className='m-auto flex h-full w-full flex-col items-center justify-center gap-2'>
        {!minimal && (
          <h1 className='text-[7rem] leading-tight font-bold'>{t('errors.general.title')}</h1>
        )}
        <span className='font-medium'>{t('errors.general.heading')}</span>
        <p className='text-muted-foreground text-center'>
          {t('errors.general.message')}
        </p>
        {!minimal && (
          <div className='mt-6 flex gap-4'>
            <Button variant='outline' onClick={() => history.go(-1)}>
              {t('errors.general.goBack')}
            </Button>
            <Button onClick={handleBackToHome}>{t('errors.general.backToHome')}</Button>
          </div>
        )}
      </div>
    </div>
  )
}
